import { useEffect, useState } from "react";
import {
  Box, Button, Stack, TextField, Typography, Grid, MenuItem,
  Divider, FormControlLabel, Checkbox, Alert, Link, InputAdornment,
  ToggleButton, ToggleButtonGroup, Paper, Avatar, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  registrar, loginCandidato, buscarCpf, getEstados, getCidades, esqueciSenha,
} from "../../services/candidatoService";

export const SEXOS = [{ v: "M", l: "Masculino" }, { v: "F", l: "Feminino" }, { v: "O", l: "Outro" }];

export function FormCadastro({ onOk, onIrLogin }) {
  const vazio = {
    Cpf: "", Nome: "", NomeSocial: "", Email: "", DataNascimento: "", Sexo: "",
    Telefone: "", Telefone2: "", Cep: "", CodEstado: "", CodCidade: "",
    Bairro: "", Endereco: "", Numero: "", Complemento: "",
    AutorizarReceberEmail: true, AutorizarReceberTelefone: true, Senha: "",
  };
  const [f, setF] = useState(vazio);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [erro, setErro] = useState("");
  const [aviso, setAviso] = useState("");
  const [jaTemCadastro, setJaTemCadastro] = useState(false);
  const [busy, setBusy] = useState(false);
  const set = (campo, v) => setF((p) => ({ ...p, [campo]: v }));

  useEffect(() => { getEstados().then((r) => setEstados(r.data)); }, []);
  useEffect(() => {
    if (!f.CodEstado) { setCidades([]); return; }
    getCidades(f.CodEstado).then((r) => setCidades(r.data));
  }, [f.CodEstado]);

  const onBlurCpf = async () => {
    const cpf = (f.Cpf || "").replace(/\D/g, "");
    if (cpf.length !== 11) { setJaTemCadastro(false); return; }
    try {
      const { data } = await buscarCpf(cpf);
      if (!data.existe) { setAviso(""); setErro(""); setJaTemCadastro(false); return; }
      if (data.jaCadastrado) {
        // Não troca de aba automaticamente — apenas orienta e oferece ir ao login com o CPF.
        setAviso(""); setJaTemCadastro(true);
        setErro("Este CPF já possui cadastro. Faça login para continuar.");
        return;
      }
      setErro(""); setJaTemCadastro(false); setAviso("Encontramos seus dados. Confira, complete o que faltar e defina uma senha.");
      const d = data.dados;
      if (d.CodEstado) { try { setCidades((await getCidades(d.CodEstado)).data); } catch (_) {} }
      setF((p) => ({
        ...p,
        Nome: d.Nome || p.Nome, NomeSocial: d.NomeSocial || p.NomeSocial, Email: d.Email || p.Email,
        DataNascimento: d.DataNascimento ? String(d.DataNascimento).slice(0, 10) : p.DataNascimento,
        Sexo: SEXOS.some((s) => s.v === d.Sexo) ? d.Sexo : p.Sexo,
        Telefone: d.Telefone || p.Telefone, Telefone2: d.Telefone2 || p.Telefone2,
        Cep: d.Cep || p.Cep, CodEstado: d.CodEstado || p.CodEstado, CodCidade: d.CodCidade || p.CodCidade,
        Bairro: d.Bairro || p.Bairro, Endereco: d.Endereco || p.Endereco,
        Numero: d.Numero || p.Numero, Complemento: d.Complemento || p.Complemento,
      }));
    } catch (_) {}
  };

  const enviar = async () => {
    setErro("");
    if (!f.Cpf || !f.Nome || !f.Email || !f.Senha) return setErro("Preencha ao menos CPF, nome, e-mail e senha.");
    setBusy(true);
    try {
      await registrar({ ...f, CodEstado: f.CodEstado || null, CodCidade: f.CodCidade || null });
      onOk();
    } catch (e) {
      setErro(e?.response?.data?.mensagem || e?.response?.data || "Falha no cadastro.");
    } finally { setBusy(false); }
  };

  const Secao = ({ titulo }) => (
    <Grid size={{ xs: 12 }}><Typography variant="subtitle2" color="primary" sx={{ mt: 1 }}>{titulo}</Typography><Divider sx={{ mt: 0.5 }} /></Grid>
  );

  return (
    <Stack spacing={2}>
      {erro && (
        <Alert severity={jaTemCadastro ? "warning" : "error"}
          action={jaTemCadastro
            ? <Button color="inherit" size="small" onClick={() => onIrLogin?.(f.Cpf)}>Entrar</Button>
            : undefined}>
          {erro}
        </Alert>
      )}
      {aviso && <Alert severity="info">{aviso}</Alert>}
      <Grid container spacing={2}>
        <Secao titulo="Dados pessoais" />
        <Grid size={{ xs: 12, sm: 4 }}><TextField fullWidth label="CPF" value={f.Cpf} onBlur={onBlurCpf} onChange={(e) => set("Cpf", e.target.value)} /></Grid>
        <Grid size={{ xs: 12, sm: 8 }}><TextField fullWidth label="Nome completo" value={f.Nome} onChange={(e) => set("Nome", e.target.value)} /></Grid>
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="Nome social (opcional)" value={f.NomeSocial} onChange={(e) => set("NomeSocial", e.target.value)} /></Grid>
        <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth type="date" label="Nascimento" InputLabelProps={{ shrink: true }} value={f.DataNascimento} onChange={(e) => set("DataNascimento", e.target.value)} /></Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
          <TextField select fullWidth label="Sexo" value={f.Sexo} onChange={(e) => set("Sexo", e.target.value)}>
            {SEXOS.map((s) => <MenuItem key={s.v} value={s.v}>{s.l}</MenuItem>)}
          </TextField>
        </Grid>

        <Secao titulo="Contato" />
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="E-mail" value={f.Email} onChange={(e) => set("Email", e.target.value)} /></Grid>
        <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="Telefone" value={f.Telefone} onChange={(e) => set("Telefone", e.target.value)} /></Grid>
        <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="Telefone 2" value={f.Telefone2} onChange={(e) => set("Telefone2", e.target.value)} /></Grid>

        <Secao titulo="Endereço" />
        <Grid size={{ xs: 6, sm: 3 }}><TextField fullWidth label="CEP" value={f.Cep} onChange={(e) => set("Cep", e.target.value)} /></Grid>
        <Grid size={{ xs: 6, sm: 3 }}>
          <TextField select fullWidth label="Estado" value={f.CodEstado} onChange={(e) => { set("CodEstado", e.target.value); set("CodCidade", ""); }}>
            {estados.map((es) => <MenuItem key={es.CodUf} value={es.CodUf}>{es.Sigla} — {es.Nome}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField select fullWidth label="Cidade" value={f.CodCidade} disabled={!f.CodEstado} onChange={(e) => set("CodCidade", e.target.value)}>
            {cidades.map((c) => <MenuItem key={c.CodMunicipio} value={c.CodMunicipio}>{c.Municipio}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, sm: 5 }}><TextField fullWidth label="Endereço" value={f.Endereco} onChange={(e) => set("Endereco", e.target.value)} /></Grid>
        <Grid size={{ xs: 4, sm: 2 }}><TextField fullWidth label="Número" value={f.Numero} onChange={(e) => set("Numero", e.target.value)} /></Grid>
        <Grid size={{ xs: 8, sm: 5 }}><TextField fullWidth label="Bairro" value={f.Bairro} onChange={(e) => set("Bairro", e.target.value)} /></Grid>
        <Grid size={{ xs: 12 }}><TextField fullWidth label="Complemento" value={f.Complemento} onChange={(e) => set("Complemento", e.target.value)} /></Grid>

        <Secao titulo="Acesso e consentimentos" />
        <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth type="password" label="Senha" value={f.Senha} onChange={(e) => set("Senha", e.target.value)} /></Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel control={<Checkbox checked={f.AutorizarReceberEmail} onChange={(e) => set("AutorizarReceberEmail", e.target.checked)} />} label="Aceito receber e-mails" />
          <FormControlLabel control={<Checkbox checked={f.AutorizarReceberTelefone} onChange={(e) => set("AutorizarReceberTelefone", e.target.checked)} />} label="Aceito contato por telefone" />
        </Grid>
      </Grid>
      <Button variant="contained" size="large" onClick={enviar} disabled={busy} sx={{ py: 1.2 }}>
        {busy ? "Cadastrando…" : "Criar cadastro e continuar"}
      </Button>
    </Stack>
  );
}

export function FormLogin({ onOk, loginInicial }) {
  const [login, setLogin] = useState(loginInicial || "");
  const [senha, setSenha] = useState("");
  const [verSenha, setVerSenha] = useState(false);
  const [erro, setErro] = useState("");
  const [busy, setBusy] = useState(false);
  const [resetOpen, setResetOpen] = useState(false);

  const entrar = async () => {
    setErro(""); setBusy(true);
    try { await loginCandidato(login, senha); onOk(); }
    catch (e) { setErro(e?.response?.data?.mensagem || "Login ou senha inválida."); }
    finally { setBusy(false); }
  };

  return (
    <Stack spacing={2.5} sx={{ maxWidth: 420, mx: "auto" }}>
      {erro && <Alert severity="error">{erro}</Alert>}
      <TextField
        label="CPF ou e-mail" value={login} onChange={(e) => setLogin(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && entrar()}
        InputProps={{ startAdornment: <InputAdornment position="start"><PersonOutlineIcon color="action" /></InputAdornment> }}
      />
      <TextField
        label="Senha" type={verSenha ? "text" : "password"} value={senha}
        onChange={(e) => setSenha(e.target.value)} onKeyDown={(e) => e.key === "Enter" && entrar()}
        InputProps={{
          startAdornment: <InputAdornment position="start"><LockOutlinedIcon color="action" /></InputAdornment>,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setVerSenha((v) => !v)} edge="end" size="small">
                {verSenha ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Box sx={{ textAlign: "right", mt: -1 }}>
        <Link component="button" type="button" variant="body2" underline="hover" onClick={() => setResetOpen(true)}>
          Esqueci minha senha
        </Link>
      </Box>
      <Button variant="contained" size="large" onClick={entrar} disabled={busy}
        sx={{ py: 1.3, borderRadius: 2, textTransform: "none", fontSize: 16, fontWeight: 600 }}>
        {busy ? "Entrando…" : "Entrar"}
      </Button>
      <EsqueciSenhaDialog open={resetOpen} onClose={() => setResetOpen(false)} loginInicial={login} />
    </Stack>
  );
}

function EsqueciSenhaDialog({ open, onClose, loginInicial }) {
  const [login, setLogin] = useState(loginInicial || "");
  const [busy, setBusy] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => { if (open) { setLogin(loginInicial || ""); setEnviado(false); setMsg(""); } }, [open, loginInicial]);

  const enviar = async () => {
    if (!login.trim()) { setMsg("Informe seu CPF ou e-mail."); return; }
    setBusy(true);
    try {
      const { data } = await esqueciSenha(login.trim());
      setMsg(data?.mensagem || "Se houver cadastro, enviamos o link.");
      setEnviado(true);
    } catch (e) {
      setMsg(e?.response?.data?.mensagem || "Não foi possível solicitar agora. Tente novamente.");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Redefinir senha</DialogTitle>
      <DialogContent dividers>
        {enviado ? (
          <Alert severity="success">{msg}</Alert>
        ) : (
          <Stack spacing={2}>
            <Typography variant="body2" color="text.secondary">
              Informe o CPF ou e-mail do cadastro. Enviaremos um link de redefinição para o e-mail cadastrado.
            </Typography>
            {msg && <Alert severity="warning">{msg}</Alert>}
            <TextField autoFocus label="CPF ou e-mail" value={login} onChange={(e) => setLogin(e.target.value)} onKeyDown={(e) => e.key === "Enter" && enviar()} />
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{enviado ? "Fechar" : "Cancelar"}</Button>
        {!enviado && <Button variant="contained" onClick={enviar} disabled={busy}>Enviar link</Button>}
      </DialogActions>
    </Dialog>
  );
}

// Bloco de autenticação reutilizável (login primeiro / criar cadastro).
export function AuthTabs({ onOk, embutido = false }) {
  const [modo, setModo] = useState("login"); // login | cadastro
  const [loginInicial, setLoginInicial] = useState("");

  // Ao detectar CPF já cadastrado no formulário de cadastro, leva ao login com o CPF.
  const irParaLogin = (cpf) => { setLoginInicial(cpf || ""); setModo("login"); };

  const conteudo = (
    <>
      <ToggleButtonGroup
        exclusive value={modo} onChange={(_, v) => v && setModo(v)} fullWidth color="primary"
        sx={{ mb: 3, "& .MuiToggleButton-root": { textTransform: "none", fontWeight: 600, py: 1, borderRadius: 2 } }}
      >
        <ToggleButton value="login"><LoginIcon sx={{ mr: 1, fontSize: 20 }} />Entrar</ToggleButton>
        <ToggleButton value="cadastro"><PersonAddAltIcon sx={{ mr: 1, fontSize: 20 }} />Criar cadastro</ToggleButton>
      </ToggleButtonGroup>

      {modo === "login"
        ? <FormLogin onOk={onOk} loginInicial={loginInicial} />
        : <FormCadastro onOk={onOk} onIrLogin={irParaLogin} />}
    </>
  );

  if (embutido) return <Box>{conteudo}</Box>;

  // O cadastro tem muitos campos → card mais largo; o login fica compacto.
  const maxW = modo === "cadastro" ? 860 : 480;

  return (
    <Paper elevation={0} sx={{
      p: { xs: 2.5, sm: 4 }, maxWidth: maxW, mx: "auto", borderRadius: 3,
      border: "1px solid", borderColor: "divider",
      boxShadow: "0 10px 40px rgba(15,27,61,0.08)",
      transition: "max-width .25s ease",
    }}>
      <Stack alignItems="center" spacing={1} sx={{ mb: 3 }}>
        <Avatar sx={{ bgcolor: "primary.main", width: 52, height: 52, boxShadow: "0 6px 18px rgba(59,91,219,0.35)" }}>
          <LoginIcon />
        </Avatar>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>{modo === "login" ? "Acesse sua conta" : "Crie seu cadastro"}</Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {modo === "login" ? "Entre com seu CPF ou e-mail para continuar." : "Preencha seus dados para criar o acesso."}
        </Typography>
      </Stack>
      {/* O seletor Entrar/Criar limita a largura para não esticar demais no modo cadastro. */}
      <Box sx={{ maxWidth: 480, mx: "auto" }}>
        <ToggleButtonGroup
          exclusive value={modo} onChange={(_, v) => v && setModo(v)} fullWidth color="primary"
          sx={{ mb: 3, "& .MuiToggleButton-root": { textTransform: "none", fontWeight: 600, py: 1, borderRadius: 2 } }}
        >
          <ToggleButton value="login"><LoginIcon sx={{ mr: 1, fontSize: 20 }} />Entrar</ToggleButton>
          <ToggleButton value="cadastro"><PersonAddAltIcon sx={{ mr: 1, fontSize: 20 }} />Criar cadastro</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      {modo === "login"
        ? <FormLogin onOk={onOk} loginInicial={loginInicial} />
        : <FormCadastro onOk={onOk} onIrLogin={irParaLogin} />}
    </Paper>
  );
}
